var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('el-image',{staticClass:"frameImg",attrs:{"src":_vm.baseImgUrl + _vm.frameImg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }